module.exports = __webpack_public_path__ + "resources/img/img_dataflow_jp.003cb38d0592e93581812c8dd8267b15.png";